import Input from '../Input/Input';

import searchIcon from './search-icon.svg';

import styles from './TableActionRow.module.scss';

export interface TableActionRowProps {
  search: string;
  setSearch: (val: string) => void;
  renderAction?: React.ReactElement;
  placeholder?: string;
  renderAdditionalFilters?: () => React.ReactElement;
}

const TableActionRow = ({
  search,
  setSearch,
  placeholder = 'Search',
  renderAdditionalFilters = () => <></>,
  renderAction = <></>
}: TableActionRowProps) => {
  return (
    <div className={styles.actionRow}>
      <div className={styles.filters}>
        <Input
          id="search"
          label=""
          icon={searchIcon}
          value={search}
          setValue={setSearch}
          placeholder={placeholder}
        />
        {renderAdditionalFilters()}
      </div>
      {renderAction}
    </div>
  );
};

export default TableActionRow;
